import React from 'react';
import { branch, compose, lifecycle } from 'recompose';
import { withAnalytic } from '@skooldio/analytics-provider';

import QueryComponent from '../../GraphQL/util/QueryComponent';
import { getMyUserIconInfo } from '../../GraphQL/query/MyProfile.query';

import UserButtonView from './UserButton';
import UserErrorHandling from './UserErrorHandling';

const queryUserButton = (WrappedComponent) => (props) =>
  (
    <QueryComponent
      query={getMyUserIconInfo}
      variables={{ includeExternalProfile: true }}
      renderError={(error) => <UserErrorHandling error={error} />}
    >
      {(data) => {
        const { myProfile, externalProvider } = data;
        const { id, profilePic, firstName, displayName } = myProfile;
        const { providerName } = externalProvider || {};
        return (
          <WrappedComponent
            userId={id}
            name={firstName}
            image={profilePic}
            displayName={displayName}
            providerName={providerName}
            {...props}
          />
        );
      }}
    </QueryComponent>
  );

const updateUserId = lifecycle({
  componentDidMount() {
    this.props.onSetGAUser(this.props.userId);
  },
  componentDidUpdate(prevProps) {
    if (this.props.userId !== prevProps.userId) {
      this.props.onSetGAUser(this.props.userId);
    }
  },
});

const UserButton = compose(
  branch((props) => props.isLogin, queryUserButton),
  withAnalytic,
  updateUserId
)(UserButtonView);

export default UserButton;
